import { useInfiniteQuery } from "@tanstack/react-query";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import {
	limit,
	makeOffsetInfiniteQueryOptions,
	useResetInfiniteData,
} from "web_myplann/Api/infiniteQueryUtils";
import { getActivityV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useActivityListInfiniteQuery = (
	filterDatefrom?: string,
	filterDateto?: string,
	filterOnlyunsolved?: boolean,
	filterOnlysolved?: boolean,
	filterSortdesc?: boolean,
	pageSize: number = limit,
) => {
	const queryKey = ActivityKeys.infiniteList(
		filterDatefrom,
		filterDateto,
		filterOnlyunsolved,
		filterOnlysolved,
		filterSortdesc,
		pageSize,
	);

	useResetInfiniteData(queryKey);

	return useInfiniteQuery({
		queryKey,
		queryFn: (ctx) =>
			processResponseQuery(() =>
				getActivityV2(
					filterDatefrom,
					filterDateto,
					filterOnlyunsolved,
					filterOnlysolved,
					pageSize,
					ctx.pageParam,
					filterSortdesc,
				),
			)(ctx),
		...makeOffsetInfiniteQueryOptions({ pageSize }),
	});
};
